import React, {useState, useEffect, useContext} from "react"
import {Button, Box, Typography} from "@mui/material"
import {LoadingContext} from "@hoc/loading";
import {MessageContext} from "@hoc/messageNotification";
import Grid from '@mui/material/Grid';
import makeStyles from "@material-ui/core/styles/makeStyles";
import {useHistory} from "react-router";
import {get, remove} from "@api/category"
import {CreatePreview} from "./createPreview";
import {Item} from "./item";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import MuiAccordion from "@mui/material/Accordion";
import MuiAccordionSummary from "@mui/material/AccordionSummary";
import MuiAccordionDetails from "@mui/material/AccordionDetails";
import { styled } from "@mui/material/styles";
import ArrowForwardIosSharpIcon from "@mui/icons-material/ArrowForwardIosSharp";

const useStyles = makeStyles({
    main: {
        marginTop: '0.5em',
    },
    title: {
        fontSize: '24px',
        fontWeight: 'bold',
    },
    label: {
        fontSize: '16px',
        fontWeight: 'bold',
    },
    input: {
        margin: '0 4px',
    },
    subCategory: {
        padding: '0 0 0 50px'
    },
});

const Accordion = styled((props) => (
    <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
    border: `0px solid ${theme.palette.divider}`,
    "&:not(:last-child)": {
        borderBottom: 0
    },
    "&:before": {
        display: "none"
    }
}));

const AccordionSummary = styled((props) => (
    <MuiAccordionSummary
        expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: "0.9rem" }} />}
        {...props}
    />
))(({ theme }) => ({
    flexDirection: "row-reverse",
    "& .MuiAccordionSummary-expandIconWrapper.Mui-expanded": {
        transform: "rotate(90deg)"
    },
    "& .MuiAccordionSummary-content": {
        marginLeft: theme.spacing(1)
    }
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
    padding: theme.spacing(2),
    borderTop: "1px solid rgba(0, 0, 0, .125)"
}));


export const Categories = () => {
    const classes = useStyles();
    const history = useHistory();
    const [firstLoad, setFirstLoad] = useState(true);
    const [categories, setCategories] = useState([]);
    const {loading, setLoading} = useContext(LoadingContext);
    const {setErrorMessage} = useContext(MessageContext);

    const edit = (id) => {
        if (typeof id === 'undefined') return history.push(`/create-category/`)

        history.push(`/edit-category/${id}`)
    }

    const removeCategory = async (id) => {
        try {
            setLoading(true);
            setErrorMessage(null);

            await remove(id)

            setCategories(categories.filter((category) => category.id !== id))
        } catch (e) {
            setErrorMessage(e);
        }
        setLoading(false);
    }

    useEffect(() => {
        const loadCategory = async () => {
            try {
                setLoading(true);
                setErrorMessage(null);

                const [categories] = await get()

                setCategories(categories)
                setFirstLoad(false)
            } catch (e) {
                setErrorMessage(e);
            }
            setLoading(false);
        }

        loadCategory()
    }, [setLoading, setErrorMessage])

    if (!firstLoad && !loading && !categories.length) return <CreatePreview edit={edit}/>

    return (
        <Grid className={classes.main} container spacing={2}>
            <Grid sx={{ display: { xs: 'none', md: 'block' } }} item xs={0} md={12}>
                <Box display={"flex"} justifyContent={"space-between"}>
                    <Typography className={classes.title} component="h2">My Categories</Typography>
                    <Button variant="contained" onClick={() => edit()}>Create new category</Button>
                </Box>
            </Grid>
            <Grid sx={{ display: { md: 'none' } }} item xs={12} md={0}>
                <Box sx={{
                    textAlign: "center",
                }}>
                    <Typography className={classes.title} component="h2">My Categories</Typography>
                </Box>
            </Grid>
            <Grid sx={{ display: { md: 'none' } }} item xs={12}  md={0}>
                <Box sx={{
                    textAlign: "center",
                }}>
                    <Button variant="contained" onClick={() => edit()}>Create new category</Button>
                </Box>
            </Grid>
            <Grid item xs={6}  md={4}>
                <Typography className={classes.label} component="h4">Category Name</Typography>
            </Grid>
            <Grid item xs={6} md={4}>
                <Typography className={classes.label} component="h4">Win Chance</Typography>
            </Grid>
            <Grid item xs={0}  md={4}></Grid>
            {categories.map((category, ind) => (
                <Accordion key={ind}>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        id={`panel ${ind}`}
                    >
                        <Item category={category} removeCategory={removeCategory} edit={edit} ind={ind + category.id} subCategory={false} />
                    </AccordionSummary>
                    <AccordionDetails>
                        <Box  className={classes.subCategory}>
                            {category && category.subCategories ?
                                (category.subCategories.filter((subCategory) => subCategory).map((obj, ind) => (
                                    <Item key={ind} category={obj} ind={ind + obj.id} subCategory={true} />
                                )))
                                : ''}
                        </Box>
                    </AccordionDetails>
                </Accordion>
            ))}
        </Grid>
    )
}

